import { render, staticRenderFns } from "./registrar.component.vue?vue&type=template&id=21e8a0fb&scoped=true&"
import script from "./registrar.component.vue?vue&type=script&lang=js&"
export * from "./registrar.component.vue?vue&type=script&lang=js&"
import style0 from "./registrar.component.vue?vue&type=style&index=0&id=21e8a0fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8a0fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/webroot/appsobdemanda/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e8a0fb')) {
      api.createRecord('21e8a0fb', component.options)
    } else {
      api.reload('21e8a0fb', component.options)
    }
    module.hot.accept("./registrar.component.vue?vue&type=template&id=21e8a0fb&scoped=true&", function () {
      api.rerender('21e8a0fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/registrar.component.vue"
export default component.exports